import { ReactNode, useCallback, useState } from 'react';

import { ConfirmDialog, ConfirmDialogProps } from '../components/common/ConfirmDialog';
type State = {
  onClose: ConfirmDialogProps['onClose'];
};

type OpenModalResult = Parameters<State['onClose']>[0];

type ReturnValues = {
  confirm: (props: Omit<State, 'onClose'>) => Promise<OpenModalResult>;
  renderDialog: () => ReactNode;
};

export type UseConfirmDialogProps = {
  title?: string;
  cancelButtonTitle?: string;
  okButtonTitle?: string;
};

const useConfirmDialog = (props: UseConfirmDialogProps): ReturnValues => {
  const [state, setState] = useState<State | undefined>(undefined);
  const { title, cancelButtonTitle, okButtonTitle } = props;

  const confirm: ReturnValues['confirm'] = useCallback(
    (props) =>
      new Promise((resolve) => {
        setState({ ...props, onClose: resolve });
      }),
    []
  );

  const handleClose: State['onClose'] = useCallback(
    (options) => {
      state?.onClose(options);
      setState(undefined);
    },
    [state]
  );

  const renderDialog: ReturnValues['renderDialog'] = () => {
    return (
      <ConfirmDialog open={!!state} title={title ?? ''} cancelButtonTitle={cancelButtonTitle} okButtonTitle={okButtonTitle} onClose={handleClose} />
    );
  };

  return {
    confirm,
    renderDialog,
  };
};

export default useConfirmDialog;
